import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

export function WithdrawalPage() {
  const [amount, setAmount] = useState<string>('');
  const [pixKey, setPixKey] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const { isAuthenticated } = useAuth(); // Pega o objeto user

  const handleWithdrawal = async () => {
    const parsedAmount = parseFloat(amount);
    if (isNaN(parsedAmount) || parsedAmount <= 0) {
      setError('O valor do saque deve ser um número maior que zero.');
      return;
    }
    if (!pixKey.trim()) {
      setError('Por favor, informe sua chave PIX.');
      return;
    }
    //if (!AuthContextType) { // Verifica se o objeto user existe
      //setError('Você precisa estar logado para fazer um saque.');
      //return;
    //}

    setError(null);
    setSuccess(null);
    setLoading(true);
    /*
    try {
      const response = await api.post('https://slots.virtualebank.com.br/api/v1/request-withdrawal', {
        amount: parsedAmount,
        pix_key: pixKey,
        user_id: user.id, // Usa o id do objeto user
      });

      if (response.data.success) {
        setSuccess('Sua solicitação de saque foi enviada com sucesso! Ela será processada em breve.');
        setAmount('');
        setPixKey('');
      } else {
        setError(response.data.error || 'Não foi possível processar a solicitação.');
      }
    } catch (err) {
      setError('Ocorreu um erro no servidor. Por favor, tente mais tarde.');
      console.error(err);
    } finally {
      setLoading(false);
    }*/
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold text-center text-gray-800">Solicitar Saque</h1>
        
        {success && <p className="text-sm text-green-600 text-center bg-green-100 p-3 rounded-lg">{success}</p>}
        {error && <p className="text-sm text-red-600 text-center bg-red-100 p-3 rounded-lg">{error}</p>}

        <div className="space-y-4">
          <div>
            <label htmlFor="amount" className="text-sm font-medium text-gray-700">Valor do Saque (R$)</label>
            <input
              id="amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Ex: 100.00"
              className="w-full px-4 py-2 mt-2 text-lg border border-gray-300 rounded-lg focus:ring-primary focus:border-primary"
            />
          </div>
          <div>
            <label htmlFor="pix-key" className="text-sm font-medium text-gray-700">Chave PIX</label>
            <input
              id="pix-key"
              type="text"
              value={pixKey}
              onChange={(e) => setPixKey(e.target.value)}
              placeholder="CPF, e-mail, telefone, etc."
              className="w-full px-4 py-2 mt-2 text-lg border border-gray-300 rounded-lg focus:ring-primary focus:border-primary"
            />
          </div>
        </div>

        <button
          onClick={handleWithdrawal}
          disabled={loading}
          className="w-full px-4 py-3 font-bold text-white bg-primary rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:bg-purple-300">
          {loading ? 'Processando...' : 'Solicitar Saque'}
        </button>
      </div>
    </div>
  );
}
